import { render, staticRenderFns } from "./ChooseVersion.vue?vue&type=template&id=1d917a28&"
import script from "./ChooseVersion.vue?vue&type=script&lang=js&"
export * from "./ChooseVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports